import React from "react";
import { useTranslation } from "react-i18next";

import walkImg from "@/assets/explore-maatra/ongoing-care-walk.png";
import trendingImg from "@/assets/explore-maatra/ongoing-care-trending.png";
import medsImg from "@/assets/explore-maatra/ongoing-care-vitals.png";
import { useS3VideoUrl } from "@/hooks/useS3VideoUrl";
import {
  VIDEO_HEALTH_SUMMARY_S3_FILE,
  VIDEO_LAB_TRENDS_S3_FILE,
  VIDEO_VITALS_S3_FILE,
} from "@/utils/constants";

import ExploreScreen, { ExploreCard } from "./ExploreScreen";

const BEIGE =
  "radial-gradient(ellipse at center, rgba(236,221,184,1) 0%, rgba(245,235,225,1) 100%)";
const PINK =
  "radial-gradient(ellipse at center, rgba(245,182,231,1) 0%, rgba(244,215,233,1) 100%)";
const PURPLE =
  "radial-gradient(ellipse at center, rgba(209,193,237,1) 0%, rgba(242,225,245,1) 100%)";

const OngoingCare: React.FC = () => {
  const { t } = useTranslation();

  const walkVideoUrl = useS3VideoUrl(VIDEO_HEALTH_SUMMARY_S3_FILE);
  const trendingVideoUrl = useS3VideoUrl(VIDEO_LAB_TRENDS_S3_FILE);
  const medsVideoUrl = useS3VideoUrl(VIDEO_VITALS_S3_FILE);

  const cards: [ExploreCard, ExploreCard, ExploreCard] = [
    {
      img: walkImg,
      title: t("auth.ongoingCare.cards.walk"),
      thumbGradient: BEIGE,
      videoUrl: walkVideoUrl,
      imgStyle: {
        width: "100%",
        height: "100%",
        left: "0px",
        top: "0px",
        objectPosition: "86.3% 100%",
      },
    },
    {
      img: trendingImg,
      title: t("auth.ongoingCare.cards.trending"),
      thumbGradient: PINK,
      videoUrl: trendingVideoUrl,
      imgStyle: {
        width: "100%",
        height: "100%",
        left: "0px",
        top: "0px",
        objectPosition: "70.6% 100%",
      },
    },
    {
      img: medsImg,
      title: t("auth.ongoingCare.cards.meds"),
      thumbGradient: PURPLE,
      videoUrl: medsVideoUrl,
      imgStyle: {
        width: "100%",
        height: "100%",
        left: "0px",
        top: "0px",
        objectPosition: "46.7% 40%",
      },
    },
  ];

  return (
    <ExploreScreen
      pill={t("auth.ongoingCare.pill")}
      bodyText={t("auth.ongoingCare.bodyText")}
      cards={cards}
    />
  );
};

export default OngoingCare;
